export enum AccessLevelEnum {
  SYSTEM = 'SYSTEM',
  ADMIN = 'ADMIN',
  EMPLOYEE = 'EMPLOYEE',
}
